import { render } from "./TokenListsListItem.vue?vue&type=template&id=9906a844"
import script from "./TokenListsListItem.vue?vue&type=script&lang=ts"
export * from "./TokenListsListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script